export const nhomHang = {
  sections: {
    list: { title: 'Item groups' },
    tree: { title: 'Item groups — Tree view' },
    viewBasic: 'Basic information',
    viewLinkage: 'Parent group',
    viewStatus: 'Status',
    viewAudit: 'History',
  },
  hints: {
    organize: 'Organize item groups hierarchically to filter and bulk-select products faster.',
    description: 'Manage products by category, feature, and function.',
  },
  fields: {
    code: 'Code',
    name: 'Name',
    description: 'Description',
    parentGroup: 'Parent group',
    level: 'Level',
    productCount: 'Items',
    status: 'Status',
    onOffAction: 'On/Off',
    listOrder: 'Order',
    createdAt: 'Created',
    updatedAt: 'Updated',
    actions: 'Actions',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
    all: 'All',
  },
  filters: {
    all: 'All',
    groupTreeSection: 'Product groups',
    treeAll: 'All groups',
    treeSearch: 'Search product groups',
    statusSection: 'Status',
    relatedSection: 'Related',
    relatedHint: 'Open the product list to assign groups to items.',
    openProducts: 'Product list',
    maNhomCha: 'Parent group code',
    sortSection: 'Sort',
  },
  trangThai: {
    DANG_HOAT_DONG: 'Active',
    NGUNG_HOAT_DONG: 'Suspended',
  },
  placeholders: {
    searchParentNhomHang: 'Select parent group',
    searchCodeName: 'By code or group name',
    maAuto: 'Auto: NHTBPC001, level 2 NHTBPC001-01, level 3 NHTBPC001-01-01',
    tenNhom: 'Enter group name',
  },
  messages: {
    noData: 'No data',
    listSummary: 'Total records: {count}',
    listSummaryKiot: 'Total {count} groups matching filters',
    saving: 'Saving…',
    createSuccess: 'Item group created',
    updateSuccess: 'Item group updated',
    deleteSuccess: 'Item group deleted',
    deleteError: 'Could not delete item group',
    deleteSelected: 'Delete selected ({count})',
    selectedCount: 'Selected: {count}',
    bulkDeleteConfirm:
      'Delete {count} selected group(s)? (One API call per row; delete children first if parent fails.)',
    bulkDeleteSuccess: 'Deleted {count} group(s)',
    bulkDeletePartial: 'Deleted {ok}/{total}. {failed} could not be deleted.',
    bulkDeleteError: 'Bulk delete failed',
    bulkDeleteNoneSelected: 'No groups selected',
    loadError: 'Failed to load data',
    confirmDelete: 'Delete group «{name}»?',
    searchPlaceholder: 'Filter by code or name…',
    reorderError: 'Could not update order',
    exportComingSoon: 'Export for item groups is coming soon',
  },
  import: {
    description: 'Select an Excel (.xlsx) file: Group code, Name, Status, Parent code.',
    success: 'Item groups imported successfully',
    failed: 'Item group import failed',
    noData: 'No valid data rows in file',
    noSheet: 'Excel file has no data sheet',
  },
  actions: {
    addChild: 'Add child',
    moveUp: 'Move up',
    moveDown: 'Move down',
    toggleStatus: 'Toggle status',
    createInline: 'Create new',
  },
  tabs: {
    info: 'Details',
    products: 'Products',
  },
  products: {
    hint: 'Products',
    export: 'Export',
    create: 'Add product',
    empty: 'This group has no products',
    loadError: 'Could not load products',
    code: 'Code',
    name: 'Name',
    unit: 'Unit',
    price: 'Price',
    stock: 'Stock',
  },
  titles: {
    addNew: 'Add item group',
    addQuick: 'Quick add',
    edit: 'Edit item group',
    detail: 'Item group detail',
  },
  viewModes: {
    list: 'List view',
    tree: 'Tree view',
    level: 'Level table',
  },
  levelTable: {
    lv1: 'Code L1',
    lv2: 'Code L2',
    lv3: 'Code L3',
    lv4: 'Code L4',
  },
}
